import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {FormGroupBaseComponent} from "../../formgroupbase.component";
import {InputHelper} from "../../../../Helpers/InputHelper";

@Component({
  selector: 'jbm-integer-input',
  templateUrl: './JBMIntegerInput.component.html',
  styleUrls: ['./JBMIntegerInput.component.scss']
})

export class JBMIntegerInputComponent extends FormGroupBaseComponent implements OnInit {
  @Input() type: string='text';
  @Input() maxlength: number=0;
  @Input() negativeAllowed: boolean=true;
  @Input() emptyIfZero: boolean=true;
  @Output() onBlur = new EventEmitter();

  ngOnInit() {
    if(this.type==undefined) this.type='text';
    if(this.maxlength==undefined) this.maxlength=0;
    super.ngOnInit();
  }
  blur(event) {
    if(typeof this.ngControl.control.value==='number')
      this.ngControl.control.setValue(this.ngControl.control.value.toString());

    let value=this.ngControl.control.value.trim();
    if(!value) {
      this.onBlur.emit(event);
      return;
    }

    let helper=new InputHelper();
    value=helper.sanitizeIntegerValue(value, this.negativeAllowed);

    this.ngControl.control.setValue(value);
    this.onBlur.emit(event);
  }
}
